import { localStorageService } from 'shared';
const FIND_MY_ACCOUNT_KEY = 'findMyAccountAb';
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
function getFindMyAccountAb() {
    try {
        const cached = localStorage.getItem(FIND_MY_ACCOUNT_KEY);
        return cached ? JSON.parse(cached) : null;
    }
    catch {
        return null;
    }
}
function setFindMyAccountAb(data) {
    localStorageService.setItem(FIND_MY_ACCOUNT_KEY, JSON.stringify(data));
}
const assignFindMyAccountAbVariant = async (assignVariant, testSlug) => {
    const cachedData = getCachedData();
    if (cachedData && !isExpired(cachedData) && cachedData?.variant?.name) {
        return cachedData.variant.name;
    }
    try {
        const data = await assignVariant({
            testSlug: testSlug,
            postAbTestsV1ParticipantsAssignVariantTestSlug: {},
        }).unwrap();
        if (!data?.variant?.name) {
            throw new Error('Invalid API response: missing variant data');
        }
        const storageData = {
            participantUuid: data.participantUuid,
            variant: { name: data.variant.name },
            expiresAt: Date.now() + SEVEN_DAYS_MS,
        };
        setFindMyAccountAb(storageData);
        return data.variant.name;
    }
    catch (error) {
        if (cachedData?.variant?.name) {
            return cachedData.variant.name;
        }
        const fallbackData = {
            variant: { name: 'control' },
            expiresAt: Date.now() + SEVEN_DAYS_MS,
        };
        setFindMyAccountAb(fallbackData);
        return 'control';
    }
};
const getCachedData = () => {
    return getFindMyAccountAb();
};
const isExpired = (data) => {
    return Date.now() > data.expiresAt;
};
export default assignFindMyAccountAbVariant;
